module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/organize_boxes-df797866c1cd339fc77f0ba469ab0f29.png";